import React from "react";

import asIcon from "./asIcon";

export default asIcon(({ color }) => (
  <path fill={color} d="M63.7 37.7H36.3c-8 0-14.5 6.5-14.5 14.5v27.3c0 8 6.5 14.5 14.5 14.5h27.4c8 0 14.5-6.5 14.5-14.5V52.2c0-8-6.5-14.5-14.5-14.5zm5.5 41.8c0 3-2.5 5.5-5.5 5.5H36.3c-3 0-5.5-2.5-5.5-5.5V52.2c0-3 2.5-5.5 5.5-5.5h27.4c3 0 5.5 2.5 5.5 5.5v27.3zm-37-45.6c2.5 0 4.5-2 4.5-4.5 0-5.5.7-8.8 2.2-10.9S41.4 15 49.7 15c9.4 0 13 4 13 14.4a4.5 4.5 0 0 0 9 0c0-19.3-12-23.4-22-23.4-8.6 0-14.5 2.3-18 7.1s-4 10.8-4 16.2c0 2.5 2 4.5 4.4 4.6h.1z" />
));
